import { FC, SVGProps } from "react";

const Trash: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M41.0502 14.1126L40.0669 9.9355C39.846 8.99591 39.0085 8.33341 38.044 8.33341H31.2356V6.25633C31.2356 5.10216 30.2981 4.16675 29.144 4.16675H20.8252C19.671 4.16675 18.7356 5.10216 18.7356 6.25633V8.33341H12.021C11.069 8.33341 10.2377 8.98133 10.0065 9.90633L8.95854 14.0834C8.62937 15.3938 9.62104 16.6667 10.9731 16.6667H12.6231L14.4377 43.8897C14.5106 44.9834 15.421 45.8334 16.5169 45.8334H33.4523C34.5481 45.8334 35.4585 44.9834 35.5315 43.8897L37.346 16.6667H39.0273C40.3669 16.6667 41.3565 15.4167 41.0502 14.1126ZM20.8252 6.25008H29.144L29.1523 6.25633V8.33341H20.821L20.8252 6.25008ZM33.4523 43.7501H16.5169L14.7106 16.6667H35.2565L33.4523 43.7501ZM37.4856 14.5834H12.4856V14.5897H10.9794L12.021 10.4167H18.7335H31.2335H38.0377L39.0252 14.5834H37.4856Z"
        fill="#1F1F1F"
      />
      <path
        d="M19.7775 40.6208C20.3525 40.6208 20.8192 40.1542 20.8192 39.5792V20.8229C20.8192 20.2479 20.3525 19.7812 19.7775 19.7812C19.2025 19.7812 18.7358 20.2479 18.7358 20.8229V39.5792C18.7358 40.1542 19.2004 40.6208 19.7775 40.6208Z"
        fill="#1F1F1F"
      />
      <path
        d="M24.9855 40.6355C25.5605 40.6355 26.0272 40.1688 26.0272 39.5938V20.8376C26.0272 20.2626 25.5605 19.7959 24.9855 19.7959C24.4105 19.7959 23.9438 20.2626 23.9438 20.8376V39.5938C23.9438 40.1688 24.4084 40.6355 24.9855 40.6355Z"
        fill="#1F1F1F"
      />
      <path
        d="M30.194 40.6208C30.769 40.6208 31.2357 40.1542 31.2357 39.5792V20.8229C31.2357 20.2479 30.769 19.7812 30.194 19.7812C29.619 19.7812 29.1523 20.2479 29.1523 20.8229V39.5792C29.1523 40.1542 29.6169 40.6208 30.194 40.6208Z"
        fill="#1F1F1F"
      />
    </svg>
  );
};

export default Trash;
